module.exports = __webpack_public_path__ + "img/project-1.e4311e5d.jpg";